"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function domScrollbarSize() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}
exports.default = domScrollbarSize;
//# sourceMappingURL=domScrollbarSize.js.map